// University of Arizona's undergraduate majors (#2652, round 2). Read on
// 2026-10-01 from the official 2026-2027 University of Arizona Catalog
// (catalog.arizona.edu/programs). The catalog page is an app, so the list was
// read from the same program data it loads (catalog "2026-2027 University of
// Arizona Catalog", with the catalog's own filters: active, shown in the
// catalog, second majors excluded), keeping type Major with a bachelor's
// degree designation. Names are the catalog's display names; degrees are its
// own codes (BS, BA, BSBA, BAPS, BSAEE ...). Colleges are grouped by the
// catalog's college field; its abbreviations are written out ("Ag, Life &
// Envi Sci., Col of" is the College of Agriculture, Life and Environmental
// Sciences; "Soc & Behav Sci" is Social and Behavioral Sciences; "Arch, Plan
// & Lands" is Architecture, Planning and Landscape Architecture; "Zuckerman
// Coll Public Health" is the Mel and Enid Zuckerman College of Public
// Health). Held for the lead: "Food Safety" (BS) is an official major name
// that carries a guarded word; it is kept exactly (#2763).
const majors = {
    "slug": "university-of-arizona",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in the University of Arizona's official 2026-2027 Catalog, grouped by the college that offers it, with the degree it leads to. Minors, certificates, second majors and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Agriculture, Life and Environmental Sciences",
            "source": {
                "label": "University of Arizona 2026-2027 Catalog, Programs",
                "url": "https://catalog.arizona.edu/programs"
            },
            "majors": [
                {
                    "name": "Agribusiness Economics and Management",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural Systems Management",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural Technology Management and Education",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural and Applied Economics",
                    "degree": "BS"
                },
                {
                    "name": "Animal Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Applied Biotechnology",
                    "degree": "BS"
                },
                {
                    "name": "Biosystems Analytics and Technology",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BSES"
                },
                {
                    "name": "Environmental and Water Resource Economics",
                    "degree": "BS"
                },
                {
                    "name": "Family Studies and Human Development",
                    "degree": "BS"
                },
                {
                    "name": "Fashion Industry's Science and Technology",
                    "degree": "BA"
                },
                {
                    "name": "Food Safety",
                    "degree": "BS"
                },
                {
                    "name": "Human Development and Family Science",
                    "degree": "BS"
                },
                {
                    "name": "Human Services",
                    "degree": "BAPS"
                },
                {
                    "name": "Microbiology",
                    "degree": "BS"
                },
                {
                    "name": "Natural Resources",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition & Human Performance",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition and Dietetics",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition and Food Systems",
                    "degree": "BS"
                },
                {
                    "name": "Nutritional Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Nutritional Sciences and Wellness",
                    "degree": "BS"
                },
                {
                    "name": "Personal and Family Financial Planning",
                    "degree": "BS"
                },
                {
                    "name": "Plant Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Precision Nutrition and Wellness",
                    "degree": "BS"
                },
                {
                    "name": "Retailing & Consumer Science",
                    "degree": "BS"
                },
                {
                    "name": "Sustainable Plant Systems",
                    "degree": "BS"
                },
                {
                    "name": "Veterinary Science",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Architecture, Planning and Landscape Architecture",
            "source": {
                "label": "University of Arizona 2026-2027 Catalog, Programs",
                "url": "https://catalog.arizona.edu/programs"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "BARCH"
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "BLA"
                },
                {
                    "name": "Real Estate",
                    "degree": "BS"
                },
                {
                    "name": "Sustainable Built Environments",
                    "degree": "BSSBE"
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "University of Arizona 2026-2027 Catalog, Programs",
                "url": "https://catalog.arizona.edu/programs"
            },
            "majors": [
                {
                    "name": "Deaf Studies",
                    "degree": "BSED"
                },
                {
                    "name": "Early Childhood Education",
                    "degree": "BAED"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BAED"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BS"
                },
                {
                    "name": "Leadership and Learning Innovation",
                    "degree": "BS"
                },
                {
                    "name": "Literacy, Learning and Leadership",
                    "degree": "BS"
                },
                {
                    "name": "Mild to Moderate Disabilities",
                    "degree": "BSED"
                },
                {
                    "name": "Rehabilitation Studies Service",
                    "degree": "BSED"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "University of Arizona 2026-2027 Catalog, Programs",
                "url": "https://catalog.arizona.edu/programs"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "BSAEE"
                },
                {
                    "name": "Architectural Engineering",
                    "degree": "BSARE"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BSBME"
                },
                {
                    "name": "Biosystems Engineering",
                    "degree": "BSBE"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BSCHE"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BSCVE"
                },
                {
                    "name": "Computer Science and Engineering",
                    "degree": "BSCSE"
                },
                {
                    "name": "Electrical and Computer Engineering",
                    "degree": "BSECE"
                },
                {
                    "name": "Engineering Management",
                    "degree": "BSEMG"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BSEEN"
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "BSINE"
                },
                {
                    "name": "Intelligence and Information Operations",
                    "degree": "BAPS"
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "BSMSE"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BSMEE"
                },
                {
                    "name": "Mining Engineering",
                    "degree": "BSMNE"
                },
                {
                    "name": "Optical Sciences & Engineering",
                    "degree": "BSOSE"
                },
                {
                    "name": "Software Engineering",
                    "degree": "BSSFE"
                },
                {
                    "name": "Systems Engineering",
                    "degree": "BSSYE"
                }
            ]
        },
        {
            "name": "College of Fine Arts",
            "source": {
                "label": "University of Arizona 2026-2027 Catalog, Programs",
                "url": "https://catalog.arizona.edu/programs"
            },
            "majors": [
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Art and Visual Culture Education",
                    "degree": "BFA"
                },
                {
                    "name": "Dance",
                    "degree": "BFA"
                },
                {
                    "name": "Design Arts and Practice",
                    "degree": "BA"
                },
                {
                    "name": "Film and Television",
                    "degree": "BA"
                },
                {
                    "name": "Film and Television",
                    "degree": "BFA"
                },
                {
                    "name": "Live and Immersive Arts",
                    "degree": "BA"
                },
                {
                    "name": "Live and Screened Performance",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music Education",
                    "degree": "BMUS"
                },
                {
                    "name": "Music Therapy",
                    "degree": "BMUS"
                },
                {
                    "name": "Musical Theatre",
                    "degree": "BFA"
                },
                {
                    "name": "Performance",
                    "degree": "BMUS"
                },
                {
                    "name": "Studio Art",
                    "degree": "BA"
                },
                {
                    "name": "Studio Art",
                    "degree": "BFA"
                },
                {
                    "name": "Theatre Arts",
                    "degree": "BA"
                },
                {
                    "name": "Theatre Production",
                    "degree": "BFA"
                }
            ]
        },
        {
            "name": "College of Humanities",
            "source": {
                "label": "University of Arizona 2026-2027 Catalog, Programs",
                "url": "https://catalog.arizona.edu/programs"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "BA"
                },
                {
                    "name": "Applied Humanities",
                    "degree": "BA"
                },
                {
                    "name": "Classics",
                    "degree": "BA"
                },
                {
                    "name": "East Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "General Studies",
                    "degree": "BGS"
                },
                {
                    "name": "German Studies",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BIS"
                },
                {
                    "name": "Italian",
                    "degree": "BA"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Religious Studies for Health Professionals",
                    "degree": "BS"
                },
                {
                    "name": "Russian",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "World Literature",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Information Science",
            "source": {
                "label": "University of Arizona 2026-2027 Catalog, Programs",
                "url": "https://catalog.arizona.edu/programs"
            },
            "majors": [
                {
                    "name": "Applied Computing",
                    "degree": "BAPS"
                },
                {
                    "name": "Applied Science",
                    "degree": "BAPS"
                },
                {
                    "name": "Cyber Defense",
                    "degree": "BAPS"
                },
                {
                    "name": "Cyber Operations",
                    "degree": "BS"
                },
                {
                    "name": "Early Childhood",
                    "degree": "BAPS"
                },
                {
                    "name": "Emerging Technologies in Society",
                    "degree": "BA"
                },
                {
                    "name": "Game Design",
                    "degree": "BA"
                },
                {
                    "name": "Game Development",
                    "degree": "BS"
                },
                {
                    "name": "Government and Public Service",
                    "degree": "BA"
                },
                {
                    "name": "Information Science",
                    "degree": "BS"
                },
                {
                    "name": "Information Science and Arts",
                    "degree": "BA"
                },
                {
                    "name": "Information Science and Technology",
                    "degree": "BS"
                },
                {
                    "name": "Justice and Global Security",
                    "degree": "BAPS"
                },
                {
                    "name": "Organizational Leadership and Regional Commerce",
                    "degree": "BAPS"
                }
            ]
        },
        {
            "name": "College of Medicine",
            "source": {
                "label": "University of Arizona 2026-2027 Catalog, Programs",
                "url": "https://catalog.arizona.edu/programs"
            },
            "majors": [
                {
                    "name": "Emergency Medical Services",
                    "degree": "BS"
                },
                {
                    "name": "Medical Device Development and Application",
                    "degree": "BS"
                },
                {
                    "name": "Medicine",
                    "degree": "BS"
                },
                {
                    "name": "Physiology",
                    "degree": "BSHS"
                },
                {
                    "name": "Physiology and Medical Sciences",
                    "degree": "BSHS"
                }
            ]
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "University of Arizona 2026-2027 Catalog, Programs",
                "url": "https://catalog.arizona.edu/programs"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BSN"
                },
                {
                    "name": "Nursing - Collaborative Education",
                    "degree": "BSN"
                }
            ]
        },
        {
            "name": "College of Pharmacy",
            "source": {
                "label": "University of Arizona 2026-2027 Catalog, Programs",
                "url": "https://catalog.arizona.edu/programs"
            },
            "majors": [
                {
                    "name": "Medical Pharmacology and Toxicology",
                    "degree": "BS"
                },
                {
                    "name": "Pharmaceutical Sciences",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Science",
            "source": {
                "label": "University of Arizona 2026-2027 Catalog, Programs",
                "url": "https://catalog.arizona.edu/programs"
            },
            "majors": [
                {
                    "name": "Applied Physics",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence",
                    "degree": "BS"
                },
                {
                    "name": "Astronomy",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Bioinformatics",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Ecology and Evolutionary Biology",
                    "degree": "BA"
                },
                {
                    "name": "Ecology and Evolutionary Biology",
                    "degree": "BS"
                },
                {
                    "name": "Genetics and Genomics",
                    "degree": "BS"
                },
                {
                    "name": "Geosciences",
                    "degree": "BS"
                },
                {
                    "name": "Geosciences and Society",
                    "degree": "BA"
                },
                {
                    "name": "Hydrology and Atmospheric Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Molecular and Cellular Biology",
                    "degree": "BA"
                },
                {
                    "name": "Molecular and Cellular Biology",
                    "degree": "BS"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Neuroscience and Cognitive Science",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Planetary Geoscience",
                    "degree": "BS"
                },
                {
                    "name": "Psychological Science",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Science",
                    "degree": "BA"
                },
                {
                    "name": "Science",
                    "degree": "BS"
                },
                {
                    "name": "Science Law",
                    "degree": "BS"
                },
                {
                    "name": "Speech, Language and Hearing Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Statistics and Data Science",
                    "degree": "BA"
                },
                {
                    "name": "Statistics and Data Science",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Social and Behavioral Sciences",
            "source": {
                "label": "University of Arizona 2026-2027 Catalog, Programs",
                "url": "https://catalog.arizona.edu/programs"
            },
            "majors": [
                {
                    "name": "American Indian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BS"
                },
                {
                    "name": "Arabic",
                    "degree": "BA"
                },
                {
                    "name": "Care, Health and Society",
                    "degree": "BS"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Creative Writing",
                    "degree": "BA"
                },
                {
                    "name": "Criminal Justice Studies",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "Food Studies",
                    "degree": "BA"
                },
                {
                    "name": "Gender & Women's Studies",
                    "degree": "BA"
                },
                {
                    "name": "Geographic Information Systems Technology",
                    "degree": "BS"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BS"
                },
                {
                    "name": "Global Studies",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Human Rights Practice",
                    "degree": "BA"
                },
                {
                    "name": "Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Judaic Studies",
                    "degree": "BA"
                },
                {
                    "name": "Latin American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Law",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Mexican American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Middle Eastern and North African Studies",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy, Politics, Economics and Law",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Professional and Technical Writing",
                    "degree": "BA"
                },
                {
                    "name": "Public Affairs",
                    "degree": "BS"
                },
                {
                    "name": "Public Management & Policy",
                    "degree": "BS"
                },
                {
                    "name": "Public Relations",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Studies of Global Media",
                    "degree": "BA"
                },
                {
                    "name": "Urban and Regional Development",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Eller College of Management",
            "source": {
                "label": "University of Arizona 2026-2027 Catalog, Programs",
                "url": "https://catalog.arizona.edu/programs"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BSBA"
                },
                {
                    "name": "Business Administration",
                    "degree": "BSBA"
                },
                {
                    "name": "Business Analytics",
                    "degree": "BSBA"
                },
                {
                    "name": "Business Economics",
                    "degree": "BSBA"
                },
                {
                    "name": "Business Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "BSBA"
                },
                {
                    "name": "Finance",
                    "degree": "BSBA"
                },
                {
                    "name": "Integrated Business and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Management Information Systems",
                    "degree": "BSBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BSBA"
                },
                {
                    "name": "Operations and Supply Chain Management",
                    "degree": "BSBA"
                }
            ]
        },
        {
            "name": "Mel and Enid Zuckerman College of Public Health",
            "source": {
                "label": "University of Arizona 2026-2027 Catalog, Programs",
                "url": "https://catalog.arizona.edu/programs"
            },
            "majors": [
                {
                    "name": "Public Health",
                    "degree": "BS"
                },
                {
                    "name": "Wellness and Health Promotion Practice",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "W. A. Franke Honors College",
            "source": {
                "label": "University of Arizona 2026-2027 Catalog, Programs",
                "url": "https://catalog.arizona.edu/programs"
            },
            "majors": [
                {
                    "name": "Creative Intelligence and Innovation",
                    "degree": "BCII"
                }
            ]
        }
    ]
};

export default majors;
